import { createAppExt } from './app.js';
import 'scripts/controller/controller.js';
document.querySelectorAll('v-scope, [v-scope]').forEach(element => createAppExt(element));